import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getMarketplaceConfigs,
  postMarketplaceConfig,
} from '@/enteties/marketplace/api';
import type { ISubmitMarketplaceConfig } from '@/enteties/marketplace/model';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { projectKeys } from '@/enteties/project/api/projects.query-key';
import { useApiStatusToast } from 'shared/hooks/useApiStatusToast';
import * as m from '@paraglide/messages';

export const useCreateMarketplace = (
  onSuccess: () => void,
  goToStepAndSetError: (
    step: 'tariff' | 'service-type',
    name: string,
    error: string
  ) => void
) => {
  const [_, error] = useApiStatusToast();
  const queryClient = useQueryClient();
  const { selectedMarketplace, selectedProjectType } = useServiceType();

  const { data: marketPlaceConf } = useQuery({
    ...getMarketplaceConfigs.getMarketplaceConfigsQueryOptions(),
  });
  return useMutation({
    mutationFn: (config: ISubmitMarketplaceConfig) => {
      const { version } = config;
      const configData =
        marketPlaceConf?.[selectedProjectType!]?.[selectedMarketplace!]?.[
          version
        ].envvars;
      const envvarArray = [];
      const formatedConfig = config;

      if (configData) {
        for (const [key, value] of Object.entries(configData)) {
          envvarArray.push({
            name: key,
            value: config.envvars[key],
            // @ts-ignore
            isSecret: value.type === 'Secret',
          });
        }
      }
      formatedConfig.envvars = envvarArray;
      return postMarketplaceConfig(formatedConfig);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: projectKeys.allProjects,
      });
      onSuccess();
    },
    onError: (e) => {
      if (e.message.startsWith('409')) {
        goToStepAndSetError('tariff', 'name', m.create_dialog_step_error_409());
      }
      error({
        description: `${e.message}`,
      });
    },
  });
};
